// extracted by mini-css-extract-plugin
export var paginationContainer = "_92-0";